(() => {
  const q = (s, r=document) => r.querySelector(s);

  function rememberBrowseSource(){
    if (!document.body.classList.contains('template-collection') && !document.body.classList.contains('template-search')) return;
    document.addEventListener('click',(e)=>{
      const a=e.target.closest('a[href*="/products/"]');
      if(!a) return;
      try{ sessionStorage.setItem('aurymed:lastBrowseUrl', location.pathname+location.search+location.hash); }catch(_){}
    },true);
  }

  function initProductNav(){
    if (!document.body.classList.contains('template-product')) return;
    const main = q('#MainContent') || q('main');
    if (!main || q('.aury-v61-product-nav')) return;

    let backHref = '/collections/all';
    let backLabel = 'Shop';
    try {
      const stored = sessionStorage.getItem('aurymed:lastBrowseUrl');
      if (stored && (stored.includes('/collections/') || stored.includes('/search'))) backHref = stored;
      const ref = document.referrer ? new URL(document.referrer) : null;
      if (!backHref.includes('/collections/') && !backHref.includes('/search') && ref && ref.origin === location.origin && (ref.pathname.includes('/collections/') || ref.pathname.includes('/search'))) {
        backHref = ref.pathname + ref.search;
        const h = (ref.pathname.split('/collections/')[1] || '').split('/')[0];
        backLabel = h ? h.replace(/-/g,' ').replace(/\b\w/g,m=>m.toUpperCase()) : 'Kategorie';
      }
    } catch(e) {}

    const title = (q('h1')?.textContent || document.title || 'Produkt').trim();
    const nav = document.createElement('div');
    nav.className = 'aury-v61-product-nav';
    nav.innerHTML = `<nav class="aury-v61-crumbs" aria-label="Brotkrümelnavigation"><a href="/">Startseite</a><span>›</span><a href="/collections/all">Shop</a><span>›</span><span class="is-current"></span></nav><a class="aury-v61-back" href="${backHref}">← Zurück zu ${backLabel}</a>`;
    nav.querySelector('.is-current').textContent = title.length > 48 ? title.slice(0,47)+'…' : title;
    main.insertBefore(nav, main.firstChild);

    const price = q('#MainContent .product-information [class*="price"], #MainContent .product-information .price, #MainContent [class*="price"]');
    if (price && !q('.aury-v61-delivery')) {
      const hay = ((q('h1')?.textContent||'') + ' ' + document.body.textContent.slice(0,6000)).toLowerCase();
      const vibra = hay.includes('vibranex');
      const d = document.createElement('div');
      d.className = 'aury-v61-delivery';
      d.innerHTML = `<span class="aury-v61-delivery-dot" aria-hidden="true"></span><span><strong>${vibra?'5–8':'3–5'} Werktage</strong> Lieferzeit</span><span>·</span><span>${vibra?'versandkostenfrei':'5,10 € Versand · ab 69 € frei'}</span>`;
      const target = price.closest('.product-details__block') || price.parentElement || price;
      target.insertAdjacentElement('afterend', d);
    }
  }

  function initDock(){
    if (!window.matchMedia('(max-width: 989px)').matches) return;
    const dock = q('.aury-v61-mobile-dock');
    if (!dock) return;
    q('[data-v61-search]',dock)?.addEventListener('click',()=>{
      const t=q('[on\\:click="#search-modal/showDialog"]');
      if(t)t.click(); else q('#search-modal dialog')?.showModal?.();
    });
    q('[data-v61-cart]',dock)?.addEventListener('click',()=>{
      const t=q('[data-testid="cart-drawer-trigger"]'); if(t)t.click(); else location.href='/cart';
    });
    q('[data-v61-menu]',dock)?.addEventListener('click',()=>{
      const t=q('.header__icon--menu, #Details-menu-drawer-container > summary'); if(t)t.click();
    });
  }

  const boot=()=>{rememberBrowseSource();initProductNav();initDock();};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
})();
